import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import Modal from '../../Modal/Modal';
import styles from './LeaveguildModal.module.scss';
import Heading from '../../Typography/Heading/Heading';
import { useTranslation } from 'react-i18next';
import Paragraph from '../../Typography/Paragraph/Paragraph';
import Button from '../../Button/Button';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { leaveGuild } from '../../../store/reducers/Guild/guildRequest';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import Loader from '../../Loader/Loader';
import { GuildActionsName } from '../../../store/reducers/Guild/guildType';
import { clearData } from '../../../store/reducers/Guild/slice';
const LeaveGuildModal = ({ closeModal, id }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { pending, error, isDataSent } = useAppSelector((state) => state.guild);
    useEffect(() => {
        if (!error && isDataSent.includes(GuildActionsName.LEAVE_GUILD)) {
            closeModal();
            dispatch(clearData(GuildActionsName.LEAVE_GUILD));
            navigate(`/social/all-guilds`);
        }
    }, [navigate, error, dispatch, closeModal, isDataSent]);
    return (_jsxs(Modal, Object.assign({ background: true, className: styles.element, closeModal: closeModal }, { children: [_jsx(Heading, { className: styles.heading, title: t('are_you_sure_to_want_leave_the_guild') }), _jsx(Paragraph, { fontFamily: 'urbanist', color: 'grey', className: styles.desc, title: t('you_will_receive_response_to_your_app') }), pending.includes(GuildActionsName.LEAVE_GUILD) ? (_jsx(Button, { className: cn('w-100'), height: 'sm', size: '100', type: 'submit', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx(Button, { onClick: () => dispatch(leaveGuild(id)), height: 'sm', size: '100', text: t('yes_I_want_to_leave') }))] })));
};
export default LeaveGuildModal;
